import { useState } from 'react'
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from '../../../../Core/Layout/FormLayoutTwo';
import GeneralDetailsTab1 from './GeneralDetailsTab1';
import Table from './Table';
import Table2 from './Table2';
import TotalBox from './TotalBox';
import AdditionalDiscount from './AdditionalDiscount';
import Tab2Box from './Tab2Box';

function PurchaseForm() {
	const [activeTab, setActiveTab] = useState('tab1');

	const [tab1Data, setTab1Data] = useState({
		series: '',
		customer: '',
		date_of_visit: '',
		company: '',
		contact_no: '',
		customer_type: '',
		assigned_to: '',
		help_by:''
	});

	const additionalData = {
		tab1: {
			compnay: [{"name" :'Malabar gold and diamonds'}],
			customer_types: [{"name" :'Regular'},{"name" :'VIP'},{"name" :'Wholesale'}],
			assigned_to:[{"name" :'Akash'},{"name" :'Ajay'},{"name" :'Sooraj'}],
			helped_by: [{"name" :'Megha'},{"name" :'Sulekha'},{"name" :'Rahul'}],
		},
		// tab2: {
		//     industries: ['IT', 'Manufacturing', 'Healthcare'],
		//     businessSizes: ['Small', 'Medium', 'Large']
		// }
	};

	const tabs = [
		{ id: 'tab1', label: 'General Details', component: GeneralDetailsTab1 },
		{ id: 'tab2', label: 'Address & Contact', component: Tab2Box },
	];

	const updateTab1 = (field, value) => {
		console.log(field, value, "check-one");

		setTab1Data(prev => ({ ...prev, [field]: value }));
	};

	// const updateTab2 = (field, value) => {
	//     setTab2Data(prev => ({ ...prev, [field]: value }));
	// };

	const resetTab1 = () => setTab1Data({
		customerName: '', email: '', phone: '', dateOfBirth: '', gender: '', occupation: ''
	});

	// const resetTab2 = () => setTab2Data({
	//     companyName: '', taxId: '', businessType: '', industry: '', employeeCount: '', annualRevenue: ''
	// });

	const resetAll = () => {
		resetTab1();
		// resetTab2();
	};

	const handleSubmit = () => {
		const allData = {
			basicInfo: tab1Data,
			// companyInfo: tab2Data
		};
		console.log('Submitting:', allData);
	};
const getCurrentTabInfo = () => {
	switch (activeTab) {
		case 'tab1':
			return {
				component: GeneralDetailsTab1,
				data: tab1Data,
				onChange: updateTab1,
				extraData: additionalData.tab1
			};
		
		case 'tab2':
		    return {
		        component: Tab2Box,
		        data: tab1Data,
		        onChange: updateTab1,
		        extraData: additionalData.tab1
		    };
		
		default:
			return null;
	}
};

	const currentTab = getCurrentTabInfo();
	const CurrentComponent = currentTab?.component;

	return (
		<FormLayoutTwo
			title="New Purchase Order"
			breadcrumbs={[
				{ label: "Inbound" },
				{
					label: "Purchase Order List",
					url: "/inbound/purchaseorder/purchase-orders",
				},
			]}
			status={'New'}
			actionButtons={
				<>
					<Button
						className="custom-btn-00989New"
						// iconName="LuFilePlus2"
						onClick={handleSubmit}
						iconSize={12}
					>
						Get Items From Open Material Request
					</Button>
					<Button
						className="custom-btn-00989"
						iconName="LuFilePlus2"
						onClick={handleSubmit}
						iconSize={12}
					>
						Save
					</Button>

				

					<Button
						to="/brand/create-brand"
						className="px-2"
						imgSrc={printerimg}
						imgStyle={{ width: '21px' }}
					/>
				</>
			}
		>
			<div style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>


				<div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
					<div className="d-flex justify-content-between align-items-end">
						<ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
							{tabs.map((tab) => (
								<li key={tab.id} className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
									<a
										className={`removeborder234 nav-link ${activeTab === tab.id
											? 'active-tab-custom-new text-white'
											: 'tab-inactive-custom'
											} border-radius-top-corner`}
										onClick={() => setActiveTab(tab.id)}
										style={{ cursor: 'pointer' }}
									>
										{tab.label}
										<GetIcon iconName={activeTab === tab.id ? "MdKeyboardArrowDown" : "MdKeyboardArrowRight"}   size={15}    />
									</a>
								</li>
							))}
						</ul>
						<div className="d-flex align-items-center mb-2 px-3">
							<GetIcon iconName="CgAttachment" size={12} />
							<span className="fw-semibold ms-1" style={{ color: "#4b002b",fontSize:'13px' }}>
								Attachments
							</span>
						</div>
					</div>
				</div>


				<div className=" " style={{background :''}}>
					<div className="row">
						<div className="col-12">
							<div >
								{CurrentComponent && currentTab && (
									<CurrentComponent
										formData={currentTab.data}
										onFieldChange={currentTab.onChange}
										extraData={currentTab.extraData}
									/>
								)}
							</div>
						</div>
					</div>
				</div>

				{activeTab == "tab1" && <div className="px-3 mb-3" style={{background :''}}>
					<div className="row">
						<div className="col-12">
							<div >
								<Table
								setselected_item_data={[]}
								rows={[]}
								setRows={()=>{}}
								list_data={()=>{}}
								po_status={""}
								 />
							</div>
						</div>
					</div>
				</div>}



              {activeTab == "tab1" && <div className="px-3" style={{background :''}}>
					<div className="row">
						<div className="col-12">
							<div >
								<Table2
								setselected_item_data={[]}
								rows={[]}
								setRows={()=>{}}
								list_data={()=>{}}
								po_status={""}
								 />
							</div>
						</div>
					</div>
				</div>}




				
               {activeTab == "tab1" && <div className="px-3 my-3" style={{background :''}}>
					<div className="row">
						<div className="col-4">
							<TotalBox />
						</div>
						<div className="col-4">
							<AdditionalDiscount />
						</div>
					</div>
				</div>}


			</div>
		</FormLayoutTwo>
	)
}

export default PurchaseForm